<template>
  <div>
      <v-row v-show="customerLoading || customerError !== null" justify="center" no-gutters>
        <v-col cols="12" xs="12" md="8">
          <v-container>
            <LoadingBarComponent v-show="customerLoading" loading-text="Loading Customer" />
            <v-alert v-if="customerError !== null" text dense type="error">
              {{ customerError }}
            </v-alert>
          </v-container>
        </v-col>
      </v-row>
      <div v-if="currentCustomer !== null">
        <v-row justify="center" no-gutters>
          <v-col cols="12" xs="12" :md="$route.name !== 'customer' ? 4 : 8">
            <v-container :class="$route.name !== 'customer' ? 'hidden-sm-and-down' : ''">
              <v-card flat :class="getTabClass">
                <CustomerTabComponent/>
              </v-card>
            </v-container>
          </v-col>
          <v-col cols="12" xs="12" md="8">
            <v-container>
              <router-view/>
            </v-container>
          </v-col>
        </v-row>
      </div>
  </div>
</template>

<script>
import CustomerTabComponent from '../components/CustomerTabComponent'
import LoadingBarComponent from '../components/LoadingBarComponent'

export default {
  name: 'Customer',
  components: {
    CustomerTabComponent,
    LoadingBarComponent
  },
  created: function () {
    if (this.currentCustomer === null) {
      this.$store.dispatch('fetchCustomers')
        .then(() => {
          this.$store.dispatch('customer/setCurrentCustomerById', parseInt(this.$route.params.customerId))
        })
        .catch(error => {
          this.$store.commit('customer/setCurrentCustomerError', error)
        })
    }
  },

  beforeRouteLeave: function (to, from, next) {
    this.$store.commit('customer/setCurrentCustomer', { data: null, error: null })
    this.$store.dispatch('customer/resetCurrentCustomerData')
    next()
  },

  computed: {
    getTabClass: function () {
      if (this.$route.name === 'customer') {
        return ''
      } else {
        return 'drawerTab'
      }
    },
    currentCustomer () {
      return this.$store.state.customer.currentCustomer.data
    },
    customerError: function () {
      return this.$store.state.customer.currentCustomer.error
    },
    customerLoading: function () {
      return this.$store.state.customer.currentCustomer.data === null && this.$store.state.customer.currentCustomer.error === null
    }
  }
}
</script>

<style scoped>
  @media (max-width: 960px) {
    .drawerTab {
      display: none;
    }
  }
  @media (min-width: 960px) {
    .drawerTab {
      position: fixed;
      top: 66px;
      left: 0;
      padding-bottom: 66px;
      height: 100vh;
      width: 33%;
      overflow-y: auto;
    }
  }
</style>
